import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { BusinessPartnerBySubRoute } from '../../../../interfaces/busines-partner-by-sub-route.interface';
import { formatUseGpsMode } from '../../../permission-gps.constants';

/**
 * Shows the GPS mode configured for a partner.
 *
 * The value is read-only here. Editing a single partner's GPS configuration goes through the
 * business partner edit modal, which this branch does not carry, so the cell renders text.
 * Changing the configuration for many partners at once is done from the bulk GPS dialog.
 */
@Component({
  selector: 'app-gps-mode-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: ` <span class="gps-mode-text">{{ displayValue() }}</span> `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      .gps-mode-text {
        font-size: 12px;
        line-height: normal;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GpsModeCellRendererComponent {
  readonly params = input.required<CellRendererParams<BusinessPartnerBySubRoute>>();

  readonly data = computed(() => this.params()?.data);

  readonly displayValue = computed(() => formatUseGpsMode(this.data()?.useGpsMode));
}
